<script setup lang="ts">
import { computed } from "vue";
import {
  SENSOR_SETTINGS_MAX_SCALE,
  SENSOR_SETTINGS_MIN_SCALE,
  SENSOR_SETTINGS_SELECTABLE_LIST
} from "@/services/consts";

const props = defineProps<{
  modelValue: {
    max_scale: number | null,
    min_scale: number | null,
  };
  errors: {
    'sensor_setting.max_scale': string[],
    'sensor_setting.min_scale': string[],
  };
  isInstallationOffice?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const selectableMax = computed(() => {
  let min = SENSOR_SETTINGS_MIN_SCALE;
  if (props.modelValue.min_scale !== null) min = props.modelValue.min_scale;

  return SENSOR_SETTINGS_SELECTABLE_LIST.filter((value) => {
    return value > min;
  })
})

const selectableMin = computed(() => {
  let max = SENSOR_SETTINGS_MAX_SCALE;
  if (props.modelValue.max_scale !== null) max = props.modelValue.max_scale;

  return SENSOR_SETTINGS_SELECTABLE_LIST.filter((value) => {
    return value < max;
  })
})

</script>
<template>
  <v-row
    class="text-form pl-3 my-0"
  >
    <v-col cols="3">
      <h6 class="pt-2">温度管理グラフのメモリ設定</h6>
    </v-col>
  </v-row>
  <v-row class="text-form px-3 mt-0 mb-4">
    <v-col cols="4" class="d-flex">
      <v-col cols="3">
        <h6 class="pl-3 pt-4">最大値</h6>
      </v-col>
      <v-col cols="8">
        <v-select
          v-model="modelValue.max_scale"
          density="compact"
          variant="outlined"
          hide-details="auto"
          suffix="℃"
          :items="selectableMax"
          :error-messages="errors['sensor_setting.max_scale']"
          :disabled="isInstallationOffice"
        />
      </v-col>
    </v-col>
    <v-col cols="4" class="d-flex">
      <v-col cols="3">
        <h6 class="pl-3 pt-4">最小値</h6>
      </v-col>
      <v-col col="8">
        <v-select
          v-model="modelValue.min_scale"
          density="compact"
          variant="outlined"
          hide-details="auto"
          suffix="℃"
          :items="selectableMin"
          :error-messages="errors['sensor_setting.min_scale']"
          :disabled="isInstallationOffice"
        />
      </v-col>
    </v-col>
  </v-row>
</template>
